// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__j0xd6"};